export default "__VITE_ASSET__65af0540__"